import type { Capability } from "owa-capabilities";
import type { MailboxInfo } from "owa-client-types";
import { isAccountFeatureEnabled } from "owa-feature-flags";
import { isAnalyzeContentDisabledForPrivacy } from "owa-privacy-utils/lib/selectors/isAnalyzeContentDisabledForPrivacy";
import { isServiceRequestSupportedForMailbox } from "owa-service/lib/utils/isServiceRequestSupportedForMailbox";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";

/**
 * NOTE: Please see the README for more information on how the
 * capability functions must be implemented and used.
 */
export const translatorCapability: Capability = {
    isEnabled: (mailboxInfo?: MailboxInfo) => {
        return isAccountFeatureEnabled("rp-inlineTranslation", mailboxInfo ?? getModuleContextMailboxInfo());
    },
    isSupported: (mailboxInfo?: MailboxInfo) => {
        return (!isAnalyzeContentDisabledForPrivacy() &&
            isServiceRequestSupportedForMailbox(mailboxInfo));
    },
};
